/*____________________ Server ____________________*/
export const URL_BASE = process.env.VUE_APP_BASE_URL;
export const URL_IMG = process.env.VUE_APP_IMG_URL;
export const COOKIE_HOST = process.env.VUE_APP_COOKIE_HOST
export  const IDENTITY_SERVICE  =  process.env.VUE_APP_IDENTITY_SERVICE
export const LOGOUT_URL = process.env.VUE_APP_LOGOUT_URL;
export const SOCKET_URL = process.env.VUE_APP_SOCKET_URL

export const MARKET_URL = process.env.VUE_APP_MARKET_URL
export const CABINET_URL  = process.env.VUE_APP_CABINET_URL
export const RKP_URL  = process.env.VUE_APP_RKP_URL
export const DWM_URL  = process.env.VUE_APP_DWM_URL
export const DTM_URL  = process.env.VUE_APP_DTM_URL
export const HOME_URL  = process.env.VUE_APP_HOME_URL
export const FINDOC_URL  = process.env.VUE_APP_FINDOC_URL
export const INFO_URL  = process.env.VUE_APP_INFO_URL
export const DT_POS_URL  = process.env.VUE_APP_DT_POS_URL
export const BA_URL  = process.env.VUE_APP_BA_URL
export const MODE = process.env.VUE_APP_PROJECT_MODE
export const DECRYPT_KEY =process.env.VUE_APP_DECRYPT_KEY



// /*____________________ Production ____________________*/
// export const URL_BASE = 'http://172.17.12.24:1212/api/v1/';
// export const URL_IMG = 'http://172.17.12.24:1212';
/*____________________ Test ____________________*/
// export const URL_BASE = 'http://192.168.1.223:8090/api/v1/';
// export const URL_IMG = 'http://192.168.1.223:8090';
// export const URL_BASE = 'http://172.17.100.94/api/v1/';
// export const URL_IMG = 'http://172.17.100.94';


export const LANG = 'uz';
export const IS_DEV = process.env.NODE_ENV === 'development';


export default {
	URL_BASE,
	URL_IMG,
	LANG,
	IDENTITY_SERVICE,
	IS_DEV
}
